<template>
  <div class="branded_logos">
    <!-- Cobrand: partner and Clio -->
    <div v-if="partnerTypeId === 1 && partnerLogo" class="branded__images">
      <img class="branded__image" :src="partnerLogo" :alt="`${partnerTitle} logo`">
      <div class="line">|</div>
      <img class="branded__image" :src="clioBrandedImage" alt="Clio Muse Tours logo">
    </div>

    <!-- Whitelabel: partner only -->
    <img v-else-if="partnerTypeId === 2 && partnerLogo" class="branded__image" :src="partnerLogo" :alt="`${partnerTitle} logo`">

    <!-- Default: show clio and also show partner if provided (partner next to clio) -->
    <div v-else class="branded__images">
      <img class="branded__image" :src="clioBrandedImage" alt="Clio Muse Tours logo">
      <img v-if="partnerLogo" class="branded__image" :src="partnerLogo" :alt="`${partnerTitle} logo`">
    </div>
  </div>
</template>

<script setup>
defineProps({
  partnerLogo: {
    type: String,
    default: '',
  },
  partnerTitle: {
    type: String,
    default: '',
  },
  partnerTypeId: {
    type: Number,
    default: null, // 1=cobrand, 2=whitelabel
  },
});

const clioBrandedImage = '/logos/clio-muse-tours-logo-red.svg';
</script>

<style scoped>
.branded_logos {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.branded__images {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.branded__image {
  max-height: 60px;
  width: auto;
  max-width: 180px;
  object-fit: contain;
}

.line {
  color: #ccc;
  font-size: 1.5rem;
  margin: 0 0.5rem;
}

@media (max-width: 640px) {
  .branded__image {
    max-height: 45px;
    max-width: 150px;
  }

  .line {
    font-size: 1.25rem;
  }
}
</style>